import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import type { AxiosResponse } from 'axios'
import usePrivateAxios from '../../../common/api/usePrivateAxios'
import type { TotalAvailableData, TotalAvailableResponse } from '../../../common/types/totalAvailable.type'

interface UsePaymentAdvancesTotalAvailableProps<T = TotalAvailableData> {
  enabled?: boolean
  mapper?: (data: TotalAvailableData) => T
  onSuccess?: (response?: AxiosResponse<any, any>) => void
  onError?: () => void
}

const usePaymentAdvancesTotalAvailable = <T = TotalAvailableData>({ 
  enabled, 
  mapper 
}: UsePaymentAdvancesTotalAvailableProps<T> = {}): UseQueryResult<T, unknown> => {
  const privateAxios = usePrivateAxios();

  return useQuery<TotalAvailableResponse, unknown, T>({
    queryKey: ['totalAvailable'],
    queryFn: () => {
      return privateAxios.get(`/billing/payment_advances/total_available`)
    },
    select: (data) => {
      const rawData = data?.data?.data;
      return mapper ? mapper(rawData) : rawData as T;
    },
    enabled,
  })
}

export default usePaymentAdvancesTotalAvailable